<div class="noPrint" [ngClass]="isModal ? 'modal-content modal-md' : ''">
  @if (title && isModal) {
    <div class="modal-header justify-content-center">
      <h3>{{ title | cxTranslate }}</h3>
    </div>
  }
  <div class="loader-container" #divSpinner role="status">
    <div class="loader">{{ 'spinner.loading' | cxTranslate }}</div>
  </div>
</div>
